import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { UserMessagesService } from 'src/app/services/api/user-messages.service';
import { MessageService } from 'src/app/services/api/message.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserMessage } from 'src/app/interfaces/user-message';
import { SelectionModel } from '@angular/cdk/collections';
import { Folder } from 'src/app/interfaces/folder';
import { Title } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';
import { ErrorService } from 'src/app/services/error.service';
import { FolderUpdateService } from 'src/app/services/FolderUpdateService';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent implements OnInit {
  public title: string = 'Medimail Patient - ';
  private activeFolderID: number;

  //@ts-ignore
  activeFolder: Folder;

  //displayedColumns: string[] = ['select', 'sender', 'recipient', 'objet', 'date', 'attachments', 'open','action'];
  displayedColumns: string[] = [
    'select',
    'recipient',
    'objet',
    'date',
    'attachments',
    'open',
    'action',
  ];

  //@ts-ignore
  messages: MatTableDataSource<UserMessage>;

  //@ts-ignore
  @ViewChild('paginator') paginator: MatPaginator;
  //@ts-ignore
  @ViewChild(MatSort) sort: MatSort;

  public errorMessage: string;
  public errorType: string;

  selection = new SelectionModel<UserMessage>(true, []);

  constructor(
    public activeRoute: ActivatedRoute,
    public userMessageApi: UserMessagesService,
    public messageApi: MessageService,
    public userService: UserService,
    public route: Router,
    private errorService: ErrorService,
    private titleService: Title,
    private folderUpdateService: FolderUpdateService
  ) {
    this.activeFolderID =
      this.userService.currentUser.symfonyUser.defaultFolder;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.errorMessage = '';
    this.errorType = '';
  }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params) => {
      this.activeFolderID = params.folderId;
    });

    this.userMessageApi.getMessagesFromFolder(this.activeFolderID).subscribe(
      (res) => {
        if (res.result == 'SUCCESS') {
          this.activeFolder = res.content.folder;
          this.titleService.setTitle(
            this.title + ' ' + this.activeFolder.title
          );
          this.messages = new MatTableDataSource(res.content.messages);
          setTimeout(() => (this.messages.paginator = this.paginator));
          this.messages.sort = this.sort;

          this.messages.filterPredicate = (
            data: UserMessage,
            filter: string
          ) => {
            if (this.activeFolder.type != 'receive') {
              return (
                data.messages.recipient.trim().toLowerCase().includes(filter) ||
                data.messages.objet.trim().toLowerCase().includes(filter) ||
                data.messages.date_envoi
                  .trim()
                  .toLowerCase()
                  .includes(filter) ||
                data.messages.recipient_mail
                  .trim()
                  .toLocaleLowerCase()
                  .includes(filter)
              );
            } else {
              return (
                data.messages.objet.trim().toLowerCase().includes(filter) ||
                data.messages.sender.trim().toLowerCase().includes(filter) ||
                data.messages.date_envoi
                  .trim()
                  .toLowerCase()
                  .includes(filter) ||
                data.messages.recipient_mail
                  .trim()
                  .toLocaleLowerCase()
                  .includes(filter)
              );
            }
          };
        } else {
          this.errorType = res.result;
          this.errorMessage = res.content;
        }
      },
      (resError) => {
        this.errorService.errorType = 'ERROR';
        this.errorService.errorMessage = resError.error.detail;
        this.route.navigate(['/error']);
      }
    );

    this.selection.clear();
  }

  sortData(sort: Sort) {
    const data = this.messages.data.slice();
    if (!sort.active || sort.direction === '') {
      this.messages.data = data;
      return;
    }

    this.messages.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'sender':
          return this.compare(a.messages.sender, b.messages.sender, isAsc);
        case 'recipient':
          return this.compare(
            a.messages.recipient,
            b.messages.recipient,
            isAsc
          );
        case 'objet':
          return this.compare(a.messages.objet, b.messages.objet, isAsc);
        case 'date':
          return this.compare(
            a.messages.date_envoi,
            b.messages.date_envoi,
            isAsc
          );
        case 'open':
          return this.compare(a.open, b.open, isAsc);
        default:
          return this.compare(a.messages.sender, b.messages.sender, isAsc);
      }
    });
  }

  private compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.messages.filter = filterValue;
  }

  open(row: any) {
    if (!row.open) {
      row.open = true;
      this.activeFolder.notOpen--;
      this.folderUpdateService.updateFolder([this.activeFolder]);
    }
    this.route.navigate(['/open', row.ref]);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.messages.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.messages.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: UserMessage): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.id
    }`;
  }

  delete() {
    var messageDelete = new Array();
    this.selection.selected.forEach((message) => {
      messageDelete.push(message.id);
    });

    if (messageDelete.length > 0) {
      this.messageApi.delete(messageDelete).subscribe((res) => {
        if (res.result == 'SUCCESS') {
          this.errorMessage = res.content;
          this.errorType = res.result;
          this.activeFolder.notOpen--;
          this.folderUpdateService.updateFolder([this.activeFolder]);
          this.ngOnInit();
        } else {
          this.errorMessage = res.content;
          this.errorType = res.result;
        }
      });
    }
  }

  restore() {
    var messageRestore = new Array();
    this.selection.selected.forEach((message) => {
      messageRestore.push(message.id);
    });

    if (messageRestore.length > 0) {
      this.messageApi.restore(messageRestore).subscribe((res) => {
        if (res.result == 'SUCCESS') {
          this.errorMessage = res.content;
          this.errorType = res.result;
          this.ngOnInit();
        } else {
          this.errorMessage = res.content;
          this.errorType = res.result;
        }
      });
    }
  }

  replayMessages() {
    var replayMessages = new Array();
    this.selection.selected.forEach((message) => {
      replayMessages.push(message.id);
    });

    if (replayMessages.length > 0) {
      this.messageApi.reSendSelectMessages(replayMessages).subscribe(
        (res) => {
          this.errorMessage = res.content;
          this.errorType = res.result;
        },
        (resError) => {
          this.errorType = 'ERROR';
          this.errorMessage = resError.error.detail;
        }
      );
    }
  }

  replayMessage(message: UserMessage) {
    this.messageApi.reSend(message.id).subscribe(
      (res) => {
        this.errorMessage = res.content;
        this.errorType = res.result;
      },
      (resError) => {
        this.errorType = 'ERROR';
        this.errorMessage = resError.error.detail;
      }
    );
  }

  changeFolder(select: any) {
    const messagesToMove = this.selection.selected.map((message) => message.id);

    if (messagesToMove.length === 0 || !select) return;

    let folderToMove = this.activeFolder.children.find((folder) => folder.id === select) ||
      this.activeFolder.parent?.children.find((folder) => folder.id === select) ||
      (select === this.activeFolder.parent?.id ? this.activeFolder.parent : null);

    if (!folderToMove) return;

    this.activeFolder.notOpen--;
    folderToMove.notOpen++;

    this.messageApi.move(select, messagesToMove).subscribe(
      (res) => {
        const foldersToUpdate = [this.activeFolder];
        if (folderToMove) {
          foldersToUpdate.push(folderToMove);
        }

        this.folderUpdateService.updateFolder(foldersToUpdate)

        this.errorMessage = res.content;
        this.errorType = res.result;

        if (res.result === 'SUCCESS') {
          this.ngOnInit();
        }
      },
      (resError) => {
        this.errorType = 'ERROR';
        this.errorMessage = resError.error.detail;
      }
    );
  }

}
